import React from 'react'
import { graphql } from 'gatsby'
import { PrismicLink } from '@prismicio/react'
import { StaticImage } from 'gatsby-plugin-image'

// Components
import Social from './social'

export const query = graphql`
  {
    prismicNavigation {
      ...PrismicFooterFragment
    }
    prismicConfig {
      ...PrismicCompanyFragment
    }
  }
`

const Footer = ({ data }) => {
  const footerData = data.prismicNavigation.data
  const config = data.prismicConfig.data

  return (
    <footer role='contentinfo' className='mt-auto bg-gray-800 text-gray-200'>
      <div className='max-w-screen-xl mx-auto p-8 xl:px-0 py-10 dark:border-t dark:border-gray-700'>
        <div className='grid gap-6 sm:grid-cols-2 lg:grid-cols-4'>
          {footerData.body.map((footer, index) => {
            return (
              <div className='' key={`footer-${index}`}>
                <div className='font-serif tracking-tight leading-tight text-lg text-gray-400'>{footer.primary.title}</div>
                <ul className='mt-6 space-y-3'>
                  {footer.items.map((footerItem, index) => {
                    return (
                      <li key={`footerItem-${index}`}>
                        <PrismicLink className='hover:underline hover:text-gray-50 focus:outline-none focus:ring focus:ring-purple-500' field={footerItem.link}>
                          {footerItem.link_label}
                        </PrismicLink>
                      </li>
                    )
                  })}
                </ul>
              </div>
            )
          })}
          <div className='mt-4 lg:mt-0 px-3 col-span-full items-center md:col-span-1 text-center sm:text-left gap-6 flex flex-col'>
            <div className='font-serif tracking-tight leading-tight text-lg text-gray-400'>Follow Us</div>
            <div>
              <Social />
            </div>
            <div className='font-serif tracking-tight leading-tight text-lg text-gray-400'>Supporting</div>
            <a className='hover:text-white' href='https://www.thetreeapp.org' rel='noreferrer noopener' target='_blank'>
              <StaticImage className='mt-1 ml-1' width={120} src='../images/treeapp-logo-main-white.png' alt='Treeapp logo' />
            </a>
          </div>
        </div>
      </div>
      <div className='w-full h-px bg-gradient-to-r from-fuchsia-800 via-indigo-800 to-teal-600'></div>
      <div className='mb-8 border-t border-gray-700 text-gray-400 pt-8 flex gap-2 flex-wrap justify-between max-w-screen-xl mx-auto px-8 xl:px-0 text-sm'>
        <p>
          Juniperus Digital Ltd (T/A The Juniper Studio) is a company registered in England and Wales,{' '}
          <a href='https://find-and-update.company-information.service.gov.uk/company/16017351' target='_blank' rel='noreferrer' className='hover:underline'>
            no. 16017351
          </a>
        </p>{' '}
        <p className=''>
          Crafted by {config.company_display_name} &copy; {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  )
}

export default React.memo(Footer)
